module.exports = __webpack_public_path__ + "img/openBox-zise.4f14c6fe.png";